module.exports = __webpack_public_path__ + "assets/images/social.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/social.png
// module id = 496
// module chunks = 0